import { h, Component } from 'preact';
import Toast from './Toast';
import './MobileHub.css';

export default class MobileHub extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      swipe: {},
    };
  }

  componentDidMount() {
    const zone = document.getElementById('beans-snow-mobilehub-component-mobile-toasts');
    zone.addEventListener('touchstart', this.onStart.bind(this), false);
    zone.addEventListener('mousedown', this.onStart.bind(this), false);
    zone.addEventListener('touchend', this.onEnd.bind(this), false);
    zone.addEventListener('mouseup', this.onEnd.bind(this), false);
    const { index } = this.state;
    const ecmContainerWidth = 290;
    const width = document.body.offsetWidth;
    const x = (width - ecmContainerWidth) / 2 + index * -ecmContainerWidth;
    document.getElementById('beans-snow-mobilehub-component-mobile-toasts').style.transform = `translateX(${x}px)`;
  }

  onStart(e) {
    const event = e.changedTouches ? e.changedTouches[0] : e;
    this.setState((state) => {
      const { swipe } = state;
      swipe.start = event.screenX;
      return { swipe };
    });
  }

  onEnd(e) {
    const event = e.changedTouches ? e.changedTouches[0] : e;
    this.setState(
      (state) => {
        const { swipe } = state;
        swipe.end = event.screenX;
        return { swipe };
      },
      function () {
        const { swipe } = this.state;
        if (Math.abs(swipe.start - swipe.end) > 30) {
          if (swipe.start > swipe.end) {
            this.props.onSwipeleft(-1);
          } else {
            this.props.onSwiperight(1);
          }
        }
      }
    );
  }

  onEcmClick = (ecm) => {
    this.props.bus.dispatch(ecm.ctaEvent, ecm);
  };

  render() {
    const { defaultColor, ecmList } = this.props;

    return (
      <div id="beans-snow-mobilehub-component-mobile-toasts">
        {ecmList.map((ecm, i) => (
          <div
            key={ecm.id}
            id={`toast-container-${i}`}
            className="beans-snow-mobilehub-component-toast-container"
            style={{ left: `${i * 290}px` }}
          >
            <Toast index={i} ecm={ecm} defaultColor={defaultColor} onClick={() => this.onEcmClick(ecm)} mobile />
          </div>
        ))}
      </div>
    );
  }
}
